export default __webpack_public_path__ + "static/media/blue-learning.afe7cd6e.svg";